import React, { Component } from 'react';
import classNames from 'classnames';
let i18n = require("i18next");

class Link extends Component {
    render() {

        return (
            <a className={this.props.clsName} href={"#settings/" + this.props.link}>
                {this.props.title}
            </a>
        );
    }
}

class Menu extends Component {
    render() {
        let links = [];

        if(this.props.hasBaseFeature) {
            if(this.props.hasMembership) {
                links.push('membership');
            }

            if(this.props.user.isAdmin) {
                links.push('menu');
                links.push('discount');
                links.push('table');
                links.push('payment');
            }

            links.push('user');

            if(this.props.user.isAdmin) {
                links.push('print');
                links.push('restaurant');
                links.push('quickSettings');
            }
        }

        let menuLinks = links.map(title => {
            if(title=="membership") {
                return <Link key={title} link="membershipSetting" clsName="membershipSetting membershipSchemeSetting" title={i18n.t("pos.settings.member")} />;
            } else if(title=="quickSettings") {
                return <Link key={title} link={"/quickSettings?lang=" + (this.props.restaurant.locale || 'zh_CN')} clsName="quickSettings hidden" title={i18n.t("pos.settings.quickSettings")} /> ;
            }  else if(title=="discount"){
                return <Link key={title} link={title} clsName={title} title={i18n.t("pos.settings."+title+".title")} />;
            }  else {
                return <Link key={title} link={title} clsName={title} title={i18n.t("pos.settings."+title)} />;
            }
        });

        let license = (this.props.user && this.props.user.isAdmin) && !this.props.isExpRest ?
            <Link link="license" clsName="license" title={i18n.t("pos.settings.license.label")} /> : null;

        return (
            <div className="menuList">
                <a className="navigator" href="#settings/settingsNavigator">
                    {i18n.t("restaurant.setting")}
                    <p>{i18n.t("pos.back.to.settings")}</p>
                </a>
                {menuLinks}
                {license}
            </div>
        );
    }
}

export default class SettingsView extends Component {
    render() {
        return (
            <div id="settings" className={classNames('state', 'hidden', {experienceRestaurantDialogBottom: this.props.isExpRest})}>
                <div className="sidebar">
                    <Menu {...this.props}/>
                </div>
                <div className="mainArea">
                </div>

                <div className="loading hidden">
                    <img src={require("../images/loading_big.gif")} height="64" width="64"/>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/react/SettingsView.react.js